module.exports = __webpack_public_path__ + "img/can_pickup.de149048.png";